import ExpenseFormConfig from "./form";
import GenericForm from "../GenericForm";
import { ExpenseFormData, ExpenseRelatedAttributes } from "@/formTypes/ExpenseDataType";
import { ExpenseApi, ExpenseDataType } from "@/api/ExpenseApi";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { getDefaultCurrency } from "@utils/Currency";
import { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { CurrencyIdPubSub } from "@utils/pubsubs/PubSub";
import LoadXmlDataForm from "@components/dynamic/LoadXmlDataForm";
import LoadingScreen from "@components/content/LoadingScreen";
import { loadXmlDocument } from "@utils/EDocument";
import { ExpenseCategoryApi } from "@/api/ExpenseCategoryApi";
import { showAlert } from "@utils/Alert";
import { findPropertyRecursive, omitProperties } from "@utils/Utils";
import { useAppSelector } from "@/store/hooks";
import { loadReferenceFormLabel } from "@utils/Forms";

type ExpenseFormProps = {
  id?: string;
  formId: string,
  saveRedirectUrl: string
}

const ExpenseForm = (props: ExpenseFormProps) => {
  const [defaultData, setDefaultData] = useState<ExpenseDataType>({});
  const formRef = useRef<DynamicFormRef>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const suscriptionData = useAppSelector((state) => state.suscription.suscription);
  const [formConfig, setFormConfig] = useState<any>();

  useEffect(() => {
    loadFormConfig()
  }, [suscriptionData])

  useLayoutEffect(() => {
    const run = async () => {
      const defaultCurrency = await getDefaultCurrency()
      if (defaultCurrency.id) {
        setDefaultData({ currencyId: defaultCurrency.id })
        CurrencyIdPubSub.publish({ currencyId: defaultCurrency.id, forceUpload: false })
      }
    }
    run();
  }, []);

  const loadFormConfig = () => {
    const formConfig = loadReferenceFormLabel(ExpenseFormConfig, suscriptionData);
    if (suscriptionData?.id) {
      setFormConfig(formConfig)
    }
  }

  const onXMLFileLoad = async (fileData: unknown) => {
    setIsLoading(true)
    try {
      const { documentData } = await loadXmlDocument(fileData, ["FacturaElectronica"])
      const defaultCategoria = await ExpenseCategoryApi.find({ is_default: { eq: true } });
      const emisor = findPropertyRecursive(fileData, "Emisor");

      const nombreEmisor = emisor?.Nombre || ""
      const defaultData: Partial<ExpenseFormData> = {
        ...documentData,
        monto: documentData?.total || 0,
        nombre: nombreEmisor,
        expenseCategoryId: defaultCategoria?.id || ""
      }
      const filteredDocumentData = omitProperties(defaultData || {}, ["Products", "total", "providerId", "tipo", "pagada", "numero"])

      formRef.current?.resetFormValue(filteredDocumentData);
    } catch (err) {
      if (err instanceof Error) {
        showAlert("danger", err.message)
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      {formConfig?.sections && (<>
        <LoadXmlDataForm
          onFileLoaded={onXMLFileLoad}
        />
        <GenericForm<ExpenseFormData, ExpenseDataType>
          id={props.id}
          ref={formRef}
          formId={props.formId}
          defaultData={defaultData}
          saveRedirectUrl={props.saveRedirectUrl}
          modelRelativeObjects={ExpenseRelatedAttributes}
          formConfig={formConfig}
          getById={(...arg) => ExpenseApi.get(...arg)}
          createFn={(...arg) => ExpenseApi.create(...arg)}
          updateFn={(...arg) => ExpenseApi.update(...arg)}
          successMessage="El gasto ha sido almacenada correctamente"
          errorMessage="No fue posible almacenar la información del gasto"
        />
        <LoadingScreen isLoading={isLoading} />

      </>
      )}
    </>
  )
}

export default ExpenseForm;